import {
  SAVE_SYSTEM_SETTINGS,
  SAVE_SYSTEM_SETTINGS_SUCCESS,
  SAVE_SYSTEM_SETTINGS_FAILURE,
  SAVE_SYSTEM_SETTINGS_RESET,

  GET_SYSTEM_SETTINGS,
  GET_SYSTEM_SETTINGS_SUCCESS,
  GET_SYSTEM_SETTINGS_FAILURE,
  GET_SYSTEM_SETTINGS_RESET,
} from "../ActionTypes";

const INIT_STATE = {
  systemSettings: {},

  savingSystemSettings: false,
  systemSettingsSaveSuccess: false,

  fetchingSystemSettings: false,

}

function reducers(state = INIT_STATE, action) {
  switch (action.type) {
    case SAVE_SYSTEM_SETTINGS: return {
      ...state,
      savingSystemSettings: true,
    }

    case SAVE_SYSTEM_SETTINGS_SUCCESS: return {
      ...state,
      savingSystemSettings: false,
      systemSettingsSaveSuccess: true,
      systemSettings: action.payload.data.data,
    }

    case SAVE_SYSTEM_SETTINGS_FAILURE: return {
      ...state,
      savingSystemSettings: false,
      systemSettingsSaveSuccess: false
    }

    case SAVE_SYSTEM_SETTINGS_RESET: return {
      ...state,
      savingSystemSettings: false,
      systemSettingsSaveSuccess: false,
    }


    case GET_SYSTEM_SETTINGS: return {
      ...state,
      fetchingSystemSettings: true,
    }

    case GET_SYSTEM_SETTINGS_SUCCESS: return {
      ...state,
      systemSettings: action.payload.data.data,
      fetchingSystemSettings: false,
    }

    case GET_SYSTEM_SETTINGS_FAILURE: return {
      ...state,
      fetchingSystemSettings: false,

    }

    case GET_SYSTEM_SETTINGS_RESET: return {
      ...state,
      fetchingSystemSettings: false,
      systemSettings: {},
    }


    default: return state;
  }
}

export default reducers;